import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { manageFootballTeamService } from "../../../../../../commons";

interface ITeamCoachRemoveState {
  manageTeamCoachRemoveStatus: StatusEnum;
}

const initialState: ITeamCoachRemoveState = {
  manageTeamCoachRemoveStatus: StatusEnum.Idle,
};

export interface ITeamCoachRemoveOption {
  teamId: number;
  coachId: number;
}

export const teamCoachRemove = createAsyncThunk(
  "manage/teamCoachRemove",
  async (options: ITeamCoachRemoveOption, thunkAPI) => {
    try {
      const teamCoachRemoveResponse = await manageFootballTeamService.removeTeamCoach(options.teamId, options.coachId);
      return teamCoachRemoveResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageTeamCoachRemoveSlice = createSlice({
  name: "subTeamCoachRemove",
  initialState: initialState,
  reducers: {
    cleanUpTeamCoachRemove(state) {
      state.manageTeamCoachRemoveStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(teamCoachRemove.pending, (state) => {
        state.manageTeamCoachRemoveStatus = StatusEnum.Loading;
      })
      .addCase(teamCoachRemove.fulfilled, (state, action) => {
        state.manageTeamCoachRemoveStatus = StatusEnum.Succeeded;
      })
      .addCase(teamCoachRemove.rejected, (state) => {
        state.manageTeamCoachRemoveStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpTeamCoachRemove } = manageTeamCoachRemoveSlice.actions;
export default manageTeamCoachRemoveSlice.reducer;
